export const shouldShowAskMeAnythingLauncher = ({
  useAskMeAnythingLauncher,
  hasOpenedWidget,
  mobile
}) => useAskMeAnythingLauncher && !hasOpenedWidget && !mobile;